import styled from 'styled-components';

export const SignOutWrap = styled.section``;
